import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.serivce';

/**
 *
 * An "Interceptor" class helps us send our auth token (JWT Token) on every server request automatically, without the need to specify it for every individual call
 *
 * */

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  authService: AuthenticationService;

  constructor(private injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.authService = this.injector.get(AuthenticationService);
    const jwtToken = this.authService.getAuthToken();
    
    if (jwtToken) {
      const clone = request.clone({
        headers: request.headers.set("Authorization", "Bearer " + jwtToken)
      });

      return next.handle(clone);
    } else {
      return next.handle(request);
    }
  }

}
